import { render } from "./Notificacao.vue?vue&type=template&id=c70d64a4&scoped=true&ts=true"
import script from "./Notificacao.vue?vue&type=script&lang=ts"
export * from "./Notificacao.vue?vue&type=script&lang=ts"

import "./Notificacao.vue?vue&type=style&index=0&id=c70d64a4&scoped=true&lang=css"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c70d64a4"]])

export default __exports__